// Copyright (c) 2019 Deere & Company
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { ImplicitCallback, SecureRoute, Security } from '@okta/okta-react';
import React, { Component } from 'react';
import AnalysisCommentsUpload from '../mass-update/components/analysis-comments-upload';
import AppFooter from './common/components/app-footer';
import AppHeader from './common/components/app-header';
import BatchCorrectedPartNoUploadPage from '../mass-update/components/batch-corrected-part_upload';
import BatchFactoryDataUploadPage from '../mass-update/components/batch-factory-data-upload';
import BatchTextUpload from '../mass-update/components/batch-text-upload';
import Claims from '../claims';
import ClaimsResult from '../claims/components/search-result-panel';
import ComponentFunctionCodeMaintainencePage from '../admin/component-function-code-maintenance';
import Datadog from '../config/datadog';
import FunctionCodeMaintainencePage from '../admin/function-code-maintainence';
import HomePage from '../home-page';
import IntlProvider from '../intl-provider';
import OktaState from '../okta-state/state-connector';
import PartGroupMaintenancePage from '../admin/part-group-maintenance';
import PreferencePage from '../my-preferences';
import { Provider } from 'react-redux';
import { WarrantyAlertBar } from '../shared/components/warranty-alert-bar';
import WarrantyProductStructureMaintenancePage from '../admin';
import WorkList from '../workList';
import store from '../store';
import nonDeereCliamsUpload from '../non-deere-claims/non-deere-claims-upload';
import nonDeereClaimSearch from '../non-deere-claims/nondeere-claim-search';
// import { getConfig } from './common/repositories';
// import {getBasePath} from "../shared/services/get-base-path";
// import {getOktaCredentials} from "../okta-env";
// const oktaCredentials = getOktaCredentials();
// import { getEnvironment } from '../shared/services/get-environment';
// const environment_name = getEnvironment();

function DefaultPath () {
    return (
        <div>
            <h2>Default</h2>
            {' '}
            <p>Default Route to be shown when no matching path is detected</p>
        </div>
    );

}

class WwhRoutes extends Component {
    // state = {
    //     oktaCredentials: {}
    // };
    componentWillMount () {
        if (process.env.REACT_APP_ENVIRONMENT !== 'Prod') {
            document.title = process.env.REACT_APP_ENVIRONMENT + " - Warranty Warehouse"
        }

        // const oktaAuthDetail = getOktaCredentials();
        // oktaAuthDetail["scope"] = ['profile', 'openid','authorities'];
        // // const versionDetail = {"environment" : process.env.REACT_APP_ENVIRONMENT, "apiVersion" : "1.028"}
        // this.setState( { oktaCredentials: oktaAuthDetail});

        const isIE = document.documentMode;
        if ( isIE ) {
            // eslint-disable-next-line no-alert
            alert( 'Only limited functionality supported by Internet Explorer. ' +
                'We recommend using Google Chrome, Microsoft Edge, Firefox and Safari for best experience!' );
        }

        // getConfig().then( response => {
        //     this.setState( { oktaCredentials: response.okta, configResp: response, } );
        // } ).catch( () => {
        //     // eslint-disable-next-line no-alert
        //     alert( 'NETWORK ERROR: Cannot reach API server:https://wwh.deere.com, Contact Network Administrator for help!' );
        //
        // } );

    }

    render = () => {
        // const {clientId, issuer, scope} = this.state.oktaCredentials;
        // console.log(this.state.oktaCredentials)
        const scope = ['profile', 'openid','authorities'];

        return (
            <Provider store={store}>
                <IntlProvider>
                    <Datadog />
                    <BrowserRouter>
                        { process.env.REACT_APP_CLIENT_ID && (
                            <Security
                                client_id={process.env.REACT_APP_CLIENT_ID}
                                issuer={process.env.REACT_APP_ISSUER}
                                redirect_uri={`${window.location.origin}/callback`}
                                scope={scope}
                                response_type={'token id_token'}
                            >
                                <OktaState />
                                <section className="wwh-container">
                                    <WarrantyAlertBar>
                                        <section className="app-container-without-footer">
                                            {/*<AppHeader environment={environment_name} />*/}
                                            <AppHeader />
                                            <section className="app-content">
                                                <Switch>
                                                    <SecureRoute exact path="/" component={HomePage} />
                                                    <SecureRoute path="/admin/warranty-code-maintainence" component={WarrantyProductStructureMaintenancePage} />
                                                    <SecureRoute path="/admin/function-code-maintainence" component={FunctionCodeMaintainencePage} />
                                                    <SecureRoute path="/admin/component-function-code-maintainence" component={ComponentFunctionCodeMaintainencePage} />
                                                    <SecureRoute path="/admin/part-group-maintainence" component={PartGroupMaintenancePage} />
                                                    <SecureRoute path="/massupdate/batch-factory-data-upload" component={BatchFactoryDataUploadPage} />
                                                    <SecureRoute path="/massupdate/batch-corrected-part_upload" component={BatchCorrectedPartNoUploadPage} />
                                                    <SecureRoute path="/massupdate/batch-text-upload" component={BatchTextUpload} />
                                                    <SecureRoute path="/massupdate/analysis-comments-data-upload" component={AnalysisCommentsUpload} />
                                                    <SecureRoute path="/claims/search-results" component={ClaimsResult} />
                                                    <SecureRoute path="/claims" component={Claims} />
                                                    <SecureRoute path="/workList" component={WorkList} />
                                                    <SecureRoute path="/nondeere/claim-upload" component={nonDeereCliamsUpload} />
                                                    <SecureRoute path="/nondeere/claim-search" component={nonDeereClaimSearch} />
                                                    <SecureRoute path="/preference" component={PreferencePage} />
                                                    <Route component={ImplicitCallback} path="/callback" />
                                                    <Route component={DefaultPath} />
                                                </Switch>
                                            </section>
                                            {/*<AppFooter configResp={this.state.configResp} />*/}
                                            <AppFooter />
                                        </section>
                                    </WarrantyAlertBar>
                                </section>
                            </Security>
                        )}
                    </BrowserRouter>
                </IntlProvider>
            </Provider>
        );

    }

}

export default WwhRoutes;
